import { useNavigate } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import useWizardJump from '@swf/core/hooks/useWizardJump';
import type { WizardContext } from '@swf/core/types/Wizard';

import { CancelledCashoutStatus } from '../../../../../../types/status';
import ButtonGroup from '../../../../../ButtonGroup/ButtonGroup';
import CTAButton from '../../../../../CTAButton/CTAButton';

import {
  TXTWCL_Back_to_deposit_1,
  TXTWCL_Back_to_homepage,
  TXTWCL_LetXs_playX,
  TXTWCL_Transaction_history,
  TXTWCL_Try_again
} from './ResultButtons.messages.json';

const ResultButtons: React.FC = () => {
  const wizardContext = useWizardContext() as WizardContext;

  const {
    cancelledWithdrawResult: { status },
    pendingCashouts
  } = wizardContext.data;
  const navigate = useNavigate();
  const exitWizard = useWizardExit();
  const { jumpBack } = useWizardJump();

  const singleTransaction = pendingCashouts.length === 1;

  const backToFlow = (backToDeposit = true) => {
    wizardContext.data.processToPendingCashout = true;
    delete wizardContext.values.pendingCashouts.transactions;
    delete wizardContext.values.password;
    jumpBack(
      singleTransaction && backToDeposit
        ? '#deposit.get-pending-cashouts'
        : '#deposit.deposit-pending-cashout'
    );
  };

  switch (status) {
    case CancelledCashoutStatus.COMPLETED:
      return (
        <ButtonGroup>
          <CTAButton translation={TXTWCL_LetXs_playX} type="button" onClick={exitWizard} />
          <CTAButton
            type="button"
            variant="secondary"
            onClick={() => navigate('/transaction-history')}
            translation={TXTWCL_Transaction_history}
          />
        </ButtonGroup>
      );
    case CancelledCashoutStatus.NOT_CANCELLABLE:
      return (
        <ButtonGroup>
          <CTAButton
            translation={singleTransaction ? TXTWCL_Back_to_deposit_1 : TXTWCL_Try_again}
            type="button"
            onClick={() => backToFlow()}
          />
          <CTAButton
            type="button"
            variant="secondary"
            onClick={exitWizard}
            translation={TXTWCL_Back_to_homepage}
          />
        </ButtonGroup>
      );
    default:
      return (
        <ButtonGroup>
          <CTAButton
            translation={TXTWCL_Try_again}
            type="button"
            onClick={() => backToFlow(false)}
          />
          <CTAButton
            type="button"
            variant="secondary"
            onClick={exitWizard}
            translation={TXTWCL_Back_to_homepage}
          />
        </ButtonGroup>
      );
  }
};

export default ResultButtons;
